// Utility method to delay an asynchronous execution. Used for stubs, mostly.
export function delay(timeout: number = 1000) {
    return new Promise((resolve) => {
        window.setTimeout(resolve, timeout);
    });
}
